import { render, staticRenderFns } from "./siteAdminList.vue?vue&type=template&id=605f5845&scoped=true&"
import script from "./siteAdminList.vue?vue&type=script&lang=babel&"
export * from "./siteAdminList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605f5845",
  null
  
)

export default component.exports